// 학급 관리 '이 명단으로 시작하기'에서 고른 명단. 같은 탭에서 이어지는 채점·생기부 다중 생성의 첫 이름 맞추기에만 쓴다.
const KEY = 'wq_preferred_roster';
const TTL_MS = 6 * 60 * 60 * 1000;

export const setPreferredRoster = ({ id, label }) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ id, label, at: Date.now() }));
  } catch (_error) {
    // 저장소를 못 쓰면 자동 찾기로 맞춘다.
  }
};

export const clearPreferredRoster = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (_error) {
    // 무시
  }
};

export const getPreferredRoster = (now = Date.now()) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!saved?.id || now - Number(saved.at || 0) > TTL_MS) return null;
    return { id: saved.id, label: saved.label || '' };
  } catch (_error) {
    return null;
  }
};
